// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-Ad6C","newExpiryDate":"styles_newExpiryDate__3lURd","footer":"styles_footer__29Qi0"};